import styled from "styled-components";

export const TextRight = styled.div`
  text-align: right;
`;

export const TextError = styled.span`
  color: #d63031;
`;

export default {
  container: {
    fontSize: "12px",
    lineHeight: "18px",
    color: "rgb(0, 0, 0)",
    padding: 0,
    height: "100%",
    boxSizing: "border-box",
    textAlign: "left",
  },
  containerInnerScroll: {
    width: "100%",
    overflowY: "scroll",
    paddingBottom: "15px",
  },
  row: {
    marginTop: "10px",
  },
  name: {
    fontFamily: "AvenirNext-DemiBold",
    fontWeight: "bold",
    fontSize: "16px",
    marginBottom: "4px",
    color: "#3b3b3b",
  },
  phone: {
    fontSize: "13px",
  },
  email: {
    fontSize: "13px",
    textAlign: "left",
  },
  company: {
    fontFamily: "AvenirNext-Medium",
  },
  square: {
    display: "inline-block",
    width: "6px",
    height: "6px",
    backgroundColor: "#aaa",
    marginLeft: "8px",
    marginRight: "8px",
    marginBottom: "2px",
  },
  label: {
    fontFamily: "AvenirNext-DemiBold",
    fontSize: "11px",
    fontWeight: "600",
    color: "#bebfc0",
    marginBottom: "3px",
  },
  label2: {
    fontFamily: "AvenirNext-DemiBold",
    fontSize: "13px",
    color: "#000000",
    fontWeight: "bold",
  },
  note: {
    fontSize: "13px",
    fontStyle: "italic",
  },
  code: {
    fontSize: "11px",
    background: "#fff0cf",
    padding: "3px 5px",
    borderRadius: "3px",
    color: "#8c8c8c",
  },
  inboundInfo: {
    fontFamily: "AvenirNext-Italic",
    fontSize: "10px",
    color: "#848484",
  },
  status: {
    fontFamily: "AvenirNext-Italic",
    fontSize: "10px",
    fontStyle: "italic",
  },
  shipmentDetailModal: {
    padding: "30px",
    borderRadius: 3,
    borderWidth: 1,
    borderColors: "#cfcfcf",
    overflow: "hidden",
    backgroundColor: "white !important"
  },
  shipmentTimeModal:{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  showLink: {
    fontFamily: "AvenirNext",
    fontSize: "12px",
    color: "#4a90e2",
    textDecoration: "underline",
    cursor: "pointer",
  },
  axlModal: {
    width: "1000px",
    height: "800px",
  },
  textBlur: {
    color: "transparent",
    textShadow: "0 0 10px rgba(0,0,0,0.6)",
  },
  shipmentValueModal: {
    padding: "30px",
    borderRadius: 3,
    borderWidth: 1,
    borderColors: "##cfcfcf",
    overflow: "visible"
  },
  imgBlur: {
    filter: 'blur(8px) grayscale(100%)',
    WebkitFilter: 'blur(8px) grayscale(100%)',
  },
};
